import FavoriteType from './enums/favoriteType';
import { 
  deleteFavoriteEpic, 
  fetchUserFavoritesEpic, 
  fetchUserProfileEpic, 
  saveFavoriteEpic } from './redux/epics';
import {
  selectEmail,
  selectFavorites,
  selectIsLoggedIn,
  selectIsProfileFavoritesLoaded,
  selectPendingSaves,
  selectUserProfileTrackingCommonProperties,
  selectUserLocation,
  selectIsAuthModalOpen,
  selectUserId,
  getUserPrefillFormData
} from './redux/selectors';
import { userProfileSlice } from './redux/slices';

require('./components/userMenu');
require('./components/sessionAliveInteraction');
require('./components/mainAuthentication');
require('./components/modal');
require('./components/favorites');
require('./redux/listeners');
require('./components/googleOneTapAuthentication');

const { actions: userProfileActions, reducer: userProfileReducers } = userProfileSlice;

export {
  selectPendingSaves,
  selectFavorites,
  selectIsProfileFavoritesLoaded,
  fetchUserProfileEpic,
  fetchUserFavoritesEpic,
  saveFavoriteEpic,
  deleteFavoriteEpic,
  userProfileActions,
  userProfileReducers,
  selectUserProfileTrackingCommonProperties,
  FavoriteType,
  selectIsLoggedIn,
  selectEmail,
  selectUserLocation,
  selectIsAuthModalOpen,
  selectUserId,
  getUserPrefillFormData
};
